import { useSelector } from 'react-redux';
// @ts-expect-error not typed
import { calculateUnseenThreadsCount } from '../../threads/selectors/calculateUnseenThreadsCount';
import { getColoring } from '../../selectors/widgetDataSelectors/getColoring';
import { getIsOpen } from '../../selectors/getIsOpen';
import { getShowLauncherBadge } from '../../visitor-widget/selectors/getShowLauncherBadge';
import { getIsResponderAI } from 'conversations-internal-schema/responders/operators/responderGetters';
import { getWidgetSize } from '../../widget-size/widgetSizeSelectors';
import { useContext } from 'react';
import { BrowserWindowContext } from '../../components/BrowserWindowContext';
import { getSendFrom } from '../../widget-data/selectors/getSendFrom';
import LauncherContainer from 'conversations-visitor-experience-components/visitor-widget/LauncherContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const useComponent = () => {
  const {
    browserWindowWidth
  } = useContext(BrowserWindowContext);
  const badgeNumber = useSelector(calculateUnseenThreadsCount);
  const coloring = useSelector(getColoring);
  const open = useSelector(getIsOpen);
  const showBadge = useSelector(getShowLauncherBadge);
  const sendFromResponders = useSelector(getSendFrom);
  const widgetSize = useSelector(getWidgetSize);
  const isResponderAI = sendFromResponders.some(responder => Boolean(getIsResponderAI(responder)));
  return {
    badgeNumber,
    coloring,
    open,
    showBadge,
    isResponderAI,
    widgetSize,
    browserWindowWidth
  };
};
const LauncherContainerWrapper = props => {
  const componentProps = useComponent();
  return /*#__PURE__*/_jsx(LauncherContainer, Object.assign({}, props, componentProps));
};
LauncherContainerWrapper.displayName = 'LauncherContainerWrapper';
export default LauncherContainerWrapper;